import { render, staticRenderFns } from "./TextFieldMoney.vue?vue&type=template&id=384947da&scoped=true"
import script from "./TextFieldMoney.vue?vue&type=script&lang=js"
export * from "./TextFieldMoney.vue?vue&type=script&lang=js"
import style0 from "./TextFieldMoney.vue?vue&type=style&index=0&id=384947da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384947da",
  null
  
)

export default component.exports